<template>
	<v-dialog
		scrollable
		:value="true"
		max-width="760px"
		@click:outside="onClose"
		@keydown.esc="onClose"
	>
		<v-card :dark="isDark">
			<v-card-title class="pa-0">
				<v-toolbar
					:color="isDark ? 'grey darken-3' : 'grey lighten-3'"
					:dark="isDark"
					flat
					dense
				>
					<v-icon left color="warning">history</v-icon>
					<v-toolbar-title>
						{{
							$t(
								section === 'education'
									? 'label.education'
									: 'label.work-experience',
							)
						}}
						— {{ $t('label.edit-history') }}
					</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<div v-for="(item, itemIndex) in items" :key="`history_${item.id}`">
					<v-row>
						<v-col cols="12" style="padding-bottom: 0">
							<strong>{{ item.user_name || '—' }}</strong>
							<span class="text--secondary">
								· {{ formatDate(item.occured || item.created) }}</span
							>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="6">
							<fieldset class="talentics-fieldset talentics-fieldset-paddings">
								<legend>{{ $t('label.before') }}</legend>
								<template v-if="item.oldRows.length > 0">
									<div
										v-for="(row, rowIndex) in item.oldRows"
										:key="`old_${itemIndex}_${rowIndex}`"
										:style="
											rowIndex < item.oldRows.length - 1
												? 'margin-bottom: 12px'
												: ''
										"
									>
										<ProfileEditHistoryRow
											:row="row"
											:section="section"
										></ProfileEditHistoryRow>
									</div>
								</template>
								<div v-else class="text--secondary">—</div>
							</fieldset>
						</v-col>
						<v-col cols="12" md="6">
							<fieldset class="talentics-fieldset talentics-fieldset-paddings">
								<legend>{{ $t('label.after') }}</legend>
								<template v-if="item.newRows.length > 0">
									<div
										v-for="(row, rowIndex) in item.newRows"
										:key="`new_${itemIndex}_${rowIndex}`"
										:style="
											rowIndex < item.newRows.length - 1
												? 'margin-bottom: 12px'
												: ''
										"
									>
										<ProfileEditHistoryRow
											:row="row"
											:section="section"
										></ProfileEditHistoryRow>
									</div>
								</template>
								<div v-else class="text--secondary">—</div>
							</fieldset>
						</v-col>
					</v-row>
					<v-divider
						v-if="itemIndex < items.length - 1"
						style="margin: 12px 0"
					></v-divider>
				</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="onClose">{{ $t('button.close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import ProfileEditHistoryRow from './ProfileEditHistoryRow';

export default {
	name: 'ProfileEditHistoryDialog',
	components: {
		ProfileEditHistoryRow,
	},
	props: {
		section: {
			type: String,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
		onClose: {
			type: Function,
			required: true,
		},
	},
	computed: {
		...mapState({
			isDark: state => state.currentUser.isDark,
		}),
	},
	methods: {
		formatDate(timestamp) {
			if (!timestamp) {
				return '';
			}
			try {
				return format(new Date(timestamp), 'dd.MM.yyyy HH:mm');
			} catch (error) {
				return '';
			}
		},
	},
};
</script>
